export default __webpack_public_path__ + "static/media/jeremie.23b5ed0e.pdf";